<template>
  <w-modal
    v-model="show"
    :submit-button="$t('buttons.save')"
    :title="title"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="save()"
    @close="close()"
  >
    <div>
      <div class="form-group col-12">
        <w-textarea :model="$schema.description" :title="$t($schema.description.$schema.title)" />
      </div>

      <div class="mb-2 presence-title text-uppercase">{{ $t('modals.players-list') }}</div>

      <div v-for="player in players" :key="player.id" class="item">
        {{ player.firstName + ' ' + player.lastName }}
        <a v-if="isPlayerPresent(player.id)" class="ml-2 fa-lg float-right" @click="uncheck(player.id)">
          <i class="fal fa-check-square check" />
        </a>

        <a v-else class="ml-2 fa-lg float-right" @click="check(player.id)">
          <i class="fal fa-square uncheck" />
        </a>
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import schema from '@/schemas/presence.schema';
import { manageMixin } from '@/mixins/manage';
import { formatTitle } from '@/utils/calendar';

const emptyData = () => ({
  date: '',
  hour: null,
  minute: null,
  scheduleContainerId: null,
  presentPlayersIds: [],
  description: ''
});

// @vuese
// Modal sprawdzania obecności
// @group Components
export default {
  name: 'PresenceModal',
  mixins: [manageMixin('presences', {}, emptyData)],
  schema,
  props: {
    // Lista zawodników
    players: {
      type: Array,
      required: true
    },
    // Wydarzenie
    event: {
      type: Object,
      required: false
    }
  },
  computed: {
    title() {
      if (this.event) {
        return formatTitle(this.event.eventDate, this.event.eventHour, this.event.eventMinute, this.event.eventTitle);
      } else if (this.stateData) {
        return formatTitle(
          this.stateData.date,
          this.stateData.hour,
          this.stateData.minute,
          this.stateData.scheduleContainer ? this.stateData.scheduleContainer.name : ''
        );
      } else {
        return '';
      }
    }
  },
  methods: {
    // @vuese
    // Sprawdza, czy dany zawodnik był obecny
    isPlayerPresent(id) {
      return this.model.presentPlayersIds.includes(id);
    },
    // @vuese
    // Dodaje obecność zawodnika
    check(id) {
      this.model.presentPlayersIds.push(id);
    },
    // @vuese
    // Usuwa obecność zawodnika
    uncheck(id) {
      const index = this.model.presentPlayersIds.findIndex(playerId => playerId === id);
      this.model.presentPlayersIds.splice(index, 1);
    }
  }
};
</script>

<style scoped>
.presence-title {
  padding: 0.4em 0.8em;
  font-size: 0.8rem;
  color: #27738d;
}
.item {
  padding: 0.4em 0.8em;
  font-size: 0.8125rem;
}
.item:hover {
  background-color: #e4e4e4;
}
.check {
  color: green;
}
.uncheck {
  color: red;
}
</style>
